import { gql } from '@apollo/client'

const SYSTEM_PROCESS_FRAGMENT = gql`
  fragment SYSTEM_PROCESS on SystemProcess {
    id
    active
    createdAt
    name
    object
    processType
    conditions {
      conditionType
      conditions {
        conditionType
        fieldName
        entityName
        action
        fieldType
        value
        fieldLinkId
        inlineFunctionId
      }
    }
    transactions {
      id
      availableToFieldIds
      availableToPositionIds
      availableToUserIds
      transactionType
      restrictFieldId
      recipients {
        sendTo
        sendToUsers
        sendToFieldIds
        sendToPositions
        sendToParentFieldIds
        sendToPreviousFieldIds
        sendToReportsToPersonByFieldIds
        sendToReportsToPositionByFieldIds
        sendToFields {
          fieldId
          fieldLinkId
        }
        sendToParentFields {
          fieldId
          fieldLinkId
        }
        sendToReportsToPersonByFields {
          fieldId
          fieldLinkId
        }
        sendToReportsToPositionByFields {
          fieldId
          fieldLinkId
        }
        sendToPreviousFields {
          fieldId
          fieldLinkId
        }
      }
      riskRecurrence {
        recurrence
        riskTemplateId
        fieldValues {
          fieldId
          fieldType
          fieldLabel
          fieldValue
        }
      }
      disableRiskRecurrence {
        riskTemplateId
      }
      enableRiskRecurrence {
        riskTemplateId
      }
      position
      fieldLinkId
      inlineFunctionId
      functionName
      fieldName
      fieldValue
      subject
      template
      relatedForms {
        position
        multiple
        riskTemplateId
        inheritToManagers
        businessRules {
          userOrPositionId
          userOrPositionFieldId
          securityProfileId
          inheritSecurityProfileId
        }
      }
      groupsSecurityAccess {
        userId
        positionId
        securityProfileId
      }
      supervisorHierarchy {
        fieldIds
      }
      relatedFormAccessList {
        riskTemplateId
        securityProfileId
      }
      createRelatedForm {
        riskTemplateId
        fieldValues {
          fieldId
          fieldType
          fieldLabel
          fieldValue
        }
      }
    }
  }
`

export const SYSTEM_PROCESSES_LIST_QUERY = gql`
  query SYSTEM_PROCESSES_LIST_QUERY($pagination: PaginationInput, $order: OrderInput, $filter: SystemProcessFilter) {
    systemProcesses(pagination: $pagination, order: $order, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        ...SYSTEM_PROCESS
      }
    }
  }
  ${SYSTEM_PROCESS_FRAGMENT}
`

export const SYSTEM_PROCESSES_LIST_PB_QUERY = gql`
  query SYSTEM_PROCESSES_LIST_PUBLIC_QUERY(
    $domain: String!
    $pagination: PaginationInput
    $order: OrderInput
    $filter: SystemProcessFilter
  ) {
    systemProcessesPublic(domain: $domain, pagination: $pagination, order: $order, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        ...SYSTEM_PROCESS
      }
    }
  }
  ${SYSTEM_PROCESS_FRAGMENT}
`

export const SYSTEM_PROCESSES_COMBINED_QUERY = gql`
  query SYSTEM_PROCESSES_COMBINED_QUERY($filter: SystemProcessFilter, $entityId: ID!) {
    systemProcesses(filter: $filter, pagination: { pageSkip: 0, pageTake: 1000 }) {
      data {
        id
        active
        transactions {
          id
          transactionType
          functionName
        }
      }
    }
    getInlineFunctions(entityId: $entityId) {
      id
      functionName
      transactionId
    }
  }
`

export const INLINE_FUNCTIONS_QUERY = gql`
  query INLINE_FUNCTIONS_QUERY($entityId: ID!) {
    getInlineFunctions(entityId: $entityId) {
      id
      functionName
      transactionId
    }
  }
`
